import {useCallback} from 'react';

import {DOWNLOAD_APP_EVENTS} from '@/app/auth/events/DownloadAppEvents';
import {USER_REDIRECTION_EVENTS} from '@/app/auth/events/UserRedirectionEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useDownloadAppTrackers = () => {
  const {trackEvent} = useTrackingManager();

  // Authentication events
  const trackViewDownloadApp = useCallback(() => {
    trackEvent(DOWNLOAD_APP_EVENTS.VIEW_AUTHENTICATION_DOWNLOAD_APP, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackAuthenticationSelectDownloadApp = useCallback(() => {
    trackEvent(DOWNLOAD_APP_EVENTS.SELECT_AUTHENTICATION_DOWNLOAD_APP, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  // Parent events
  const trackParentViewDownloadApp = useCallback(
    (previousScreen: string) => {
      trackEvent(DOWNLOAD_APP_EVENTS.VIEW_DOWNLOAD_APP, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        Web: {
          screen: {
            previous: previousScreen,
          },
        },
      });
    },
    [trackEvent],
  );

  const trackParentSelectDownloadApp = useCallback(() => {
    trackEvent(DOWNLOAD_APP_EVENTS.SELECT_DOWNLOAD_APP, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackSelectOpenModakRegister = useCallback(() => {
    trackEvent(DOWNLOAD_APP_EVENTS.SELECT_OPEN_MODAK_REGISTER, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackSelectOpenMbxPolicy = useCallback(() => {
    trackEvent(DOWNLOAD_APP_EVENTS.SELECT_OPEN_MBX_POLICY, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  // Kid events
  const trackViewKidRedirection = useCallback(() => {
    trackEvent(USER_REDIRECTION_EVENTS.VIEW_REDIRECTION_PAGE, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackKidSelectDownloadApp = useCallback(() => {
    trackEvent(USER_REDIRECTION_EVENTS.SELECT_DOWNLOAD_APP, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  return {
    trackParentViewDownloadApp,
    trackParentSelectDownloadApp,
    trackSelectOpenModakRegister,
    trackSelectOpenMbxPolicy,
    trackViewKidRedirection,
    trackKidSelectDownloadApp,
    trackViewDownloadApp,
    trackAuthenticationSelectDownloadApp,
  };
};
